import { ApiProxyConnector } from "@elastic/search-ui-elasticsearch-connector";

const connector = new ApiProxyConnector({
    basePath: "/actions/search/elastic",
});

const config = {
    debug: true,
    apiConnector: connector,
    searchQuery: {
        disjunctiveFacets: [
            "Name_des_Herstellers",
            "Gruppenname",
            "Verpackungsgruppe",
            "VerkaufsME",
            "Reinheit",
            "Categorie",
            "Listenpreis",
        ],
        facets: {
            Name_des_Herstellers: {
                type: "value",
            },
            Gruppenname: {
                type: "value",
            },
            Verpackungsgruppe: {
                type: "value",
            },
            VerkaufsME: {
                type: "value",
            },
            Reinheit: {
                type: "value",
            },
            Categorie: {
                type: "value",
            },
            Listenpreis: {
                type: "range",
                ranges: [
                    { from: 0, to: 50 },
                    { from: 50, to: 100 },
                    { from: 100, to: 500 },
                    { from: 500, to: 1000 },
                    { from: 1000 },
                ],
            },
        },
    },
    autocompleteQuery: {
        results: {
            resultsPerPage: 10,
        },
    },
};

export default config;
